import { render, staticRenderFns } from "./grossing-touch-header.vue?vue&type=template&id=d2f5da7c&scoped=true&"
import script from "./grossing-touch-header.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-header.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-header.scss?vue&type=style&index=0&id=d2f5da7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f5da7c",
  null
  
)

export default component.exports